(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	var lineHeight = require('line-height');

	$('[data-excerpt]').each(function () {
		var el = $(this);
		var elHeight = el.height();
		var lines = el.attr('data-excerpt') || 2;
		var lh = lineHeight(el[0]);
		var height = parseFloat(lh) * lines;

		if (elHeight > height) {
			var readMore = $('<a role="button" class="read-more">Lue lisää...</a>').insertAfter(el);

			el.css('height', height + 'px');

			readMore.on('click', function () {
				el.addClass('open');
			});
		}
	});
})();
